import {superUser, unrestricted} from '../models/scope';

export class ModulePolicy {
  constructor(user, scopes = []) {
    this.scopes = scopes;
    this.user = user;
  }

  /**
   * @param right e.g. 'read'
   * @param options
   * @returns {boolean} has permission
   */
  // eslint-disable-next-line no-unused-vars,class-methods-use-this
  can(right, options = {}) {
    if (this.isSuperUser() || this.scopes.find((s) => s === unrestricted)) {
      return true;
    }

    if (!(this.user && this.user.scopes)) return false;

    return !!this.user.scopes
      .filter((userScope) =>
        userScope.right === right
        && this.scopes.find((s) => userScope.name === s)).length > 0;
  }

  // eslint-disable-next-line no-unused-vars,class-methods-use-this
  canView(options = {}) {
    return this.can('read', options);
  }

  // eslint-disable-next-line no-unused-vars,class-methods-use-this
  canDelete(options = {}) {
    return this.can('write', options);
  }

  // eslint-disable-next-line no-unused-vars,class-methods-use-this
  canEdit(options = {}) {
    return this.can('write', options);
  }

  // eslint-disable-next-line no-unused-vars,class-methods-use-this
  canCreate(options = {}) {
    return this.can('write', options);
  }

  // eslint-disable-next-line no-unused-vars,class-methods-use-this
  canClone(options = {}) {
    return this.can('write', options);
  }

  // eslint-disable-next-line no-unused-vars,class-methods-use-this
  canExecute(options = {exec: true}) {
    return this.can('exec', options);
  }

  // eslint-disable-next-line no-unused-vars,class-methods-use-this
  shouldNotBeSameUser(id) {
    return (id !== this.user.id);
  }

  isSuperUser() {
    return !!this.user?.scopes.find((s) => s.name === superUser);
  }
}
